import { render, staticRenderFns } from "./follow.vue?vue&type=template&id=36e8e043&"
import script from "./follow.vue?vue&type=script&lang=ts&"
export * from "./follow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports